// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-join-chat__container{width:314px;left:50%;top:50%;margin-top:-140px;margin-left:-157px;border-radius:2px}.popup-join-chat__container a{color:#0082c6}.popup-join-chat__container a:hover{color:#9a72cd}", ""]);
// Exports
module.exports = exports;
